import React from "react";
import Style from "types/globals/styleguide/style";
import StyleDataSet from "types/globals/styleguide/styleDataSet";
import StyleguideData from "types/globals/styleguide/styleguideData";
import TypographicDataSet from "types/globals/styleguide/typographicDataSet";

import getStyles from "utils/styleguide/getStyles";

const createCSSStyle = (styleguide: StyleguideData, className: string, reference: string) => {

    const breakpoint0PortraitStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 0, true);
    const breakpoint0LandscapeStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 0, false);

    const breakpoint1PortraitStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 1, true);
    const breakpoint1LandscapeStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 1, false);

    const breakpoint2PortraitStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 2, true);
    const breakpoint2LandscapeStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 2, false);

    const breakpoint3PortraitStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 3, true);
    const breakpoint3LandscapeStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 3, false);

    const breakpoint4PortraitStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 4, true);
    const breakpoint4LandscapeStyles = gatherStyles(styleguide.typographicSets, styleguide.styles, 4, false);

    const breakpoint0Portrait = getStyles(breakpoint0PortraitStyles, reference)
    const breakpoint0Landscape = getStyles(breakpoint0LandscapeStyles, reference)

    const breakpoint1Portrait = getStyles(breakpoint1PortraitStyles, reference)
    const breakpoint1Landscape = getStyles(breakpoint1LandscapeStyles, reference)

    const breakpoint2Portrait = getStyles(breakpoint2PortraitStyles, reference)
    const breakpoint2Landscape = getStyles(breakpoint2LandscapeStyles, reference)

    const breakpoint3Portrait = getStyles(breakpoint3PortraitStyles, reference)
    const breakpoint3Landscape = getStyles(breakpoint3LandscapeStyles, reference)

    const breakpoint4Portrait = getStyles(breakpoint4PortraitStyles, reference)
    const breakpoint4Landscape = getStyles(breakpoint4LandscapeStyles, reference)


    const style = `
        .`+className+` {

            font-family: "`+breakpoint0Portrait.font+`", -apple-system, BlinkMacSystemFont,
                "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
                "Droid Sans", "Helvetica Neue";

            font-style: normal;
            overflow-wrap: break-word;
        }

        @media (min-width: `+styleguide.breakpointData[0].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[0].maximumWidth+`px) and (orientation: portrait) {
            .`+className+` {
                font-size: `+breakpoint0Portrait.fontSize+`px;
                font-weight: `+breakpoint0Portrait.fontWeight+`;
                line-height: `+breakpoint0Portrait.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint0Portrait.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[0].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[0].maximumWidth+`px) and (orientation: landscape) {
            .`+className+` {
                font-size: `+breakpoint0Landscape.fontSize+`px;
                font-weight: `+breakpoint0Landscape.fontWeight+`;
                line-height: `+breakpoint0Landscape.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint0Landscape.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[1].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[1].maximumWidth+`px) and (orientation: portrait) {
            .`+className+` {
                font-size: `+breakpoint1Portrait.fontSize+`px;
                font-weight: `+breakpoint1Portrait.fontWeight+`;
                line-height: `+breakpoint1Portrait.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint1Portrait.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[1].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[1].maximumWidth+`px) and (orientation: landscape) {
            .`+className+` {
                font-size: `+breakpoint1Landscape.fontSize+`px;
                font-weight: `+breakpoint1Landscape.fontWeight+`;
                line-height: `+breakpoint1Landscape.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint1Landscape.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[2].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[2].maximumWidth+`px) and (orientation: portrait) {
            .`+className+` {
                font-size: `+breakpoint2Portrait.fontSize+`px;
                font-weight: `+breakpoint2Portrait.fontWeight+`;
                line-height: `+breakpoint2Portrait.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint2Portrait.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[2].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[2].maximumWidth+`px) and (orientation: landscape) {
            .`+className+` {
                font-size: `+breakpoint2Landscape.fontSize+`px;
                font-weight: `+breakpoint2Landscape.fontWeight+`;
                line-height: `+breakpoint2Landscape.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint2Landscape.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[3].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[3].maximumWidth+`px) and (orientation: portrait) {
            .`+className+` {
                font-size: `+breakpoint3Portrait.fontSize+`px;
                font-weight: `+breakpoint3Portrait.fontWeight+`;
                line-height: `+breakpoint3Portrait.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint3Portrait.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[3].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[3].maximumWidth+`px) and (orientation: landscape) {
            .`+className+` {
                font-size: `+breakpoint3Landscape.fontSize+`px;
                font-weight: `+breakpoint3Landscape.fontWeight+`;
                line-height: `+breakpoint3Landscape.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint3Landscape.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[4].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[4].maximumWidth+`px) and (orientation: portrait) {
            .`+className+` {
                font-size: `+breakpoint4Portrait.fontSize+`px;
                font-weight: `+breakpoint4Portrait.fontWeight+`;
                line-height: `+breakpoint4Portrait.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint4Portrait.fontSize/2+`px;
                }
            }
        }

        @media (min-width: `+styleguide.breakpointData[4].minimumWidth+`px) and (max-width: `+styleguide.breakpointData[4].maximumWidth+`px) and (orientation: landscape) {
            .`+className+` {
                font-size: `+breakpoint4Landscape.fontSize+`px;
                font-weight: `+breakpoint4Landscape.fontWeight+`;
                line-height: `+breakpoint4Landscape.lineHeight+`;
                p:not(:last-child) {
                    margin-bottom: `+breakpoint4Landscape.fontSize/2+`px;
                }
            }
        }
    `

    return style
}

const gatherStyles = (typographicSets: TypographicDataSet[], styles: StyleDataSet[], breakpoint: number, isPortrait: boolean) => {
    var stylesArray: Array<Style> = [];
    styles.map((styleDataset) => {
        // Get the style
      const styleTypographicSet = styleDataset.typographicSets[breakpoint];
      // Get the valid orientation
      const validTypographicSet = isPortrait
        ? styleTypographicSet.portrait
        : styleTypographicSet.landscape;
      // Find the matching set
      const associatedTypographicSet = typographicSets.filter(
        (set) => set.slug === validTypographicSet[0].slug
      );
      // Get the Variables
      const set = associatedTypographicSet[0];
      // Add the style with the reference
      stylesArray.push({
        title: styleDataset.title,
        slug: styleDataset.slug,
        font: set.font[0].title,
        fontSize: set.fontSize,
        fontWeight: set.fontWeight,
        lineHeight: set.lineHeight,
      });
    })

    return stylesArray
}

export default createCSSStyle